<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <b-field horizontal grouped>
        <template #label>
          {{ $t('attributes.group_cover') }}
          <b-tooltip
            type="is-dark"
            label="720x380/限定jpg檔，100KB內"
            position="is-bottom"
          >
            <b-icon size="is-small" icon="help-circle-outline"></b-icon>
          </b-tooltip>
        </template>
        <b-field class="file">
          <a class="button is-primary" @click="onSelectCoverImage">
            <b-icon icon="upload"></b-icon>
            <span>{{ $t('message.please_select_file') }}</span>
          </a>
          <p
            v-if="form.picture1"
            class="tag is-warning"
            style="margin-left: 4px; height: 36px"
          >
            <a
              :href="productImageUrl(form.picture1)"
              @click.prevent="onClickImage(form.picture1)"
            >
              {{ form.picture1 }}
            </a>
          </p>
        </b-field>
      </b-field>

      <b-field horizontal grouped>
        <template #label>
          {{ $t('attributes.route_picture') }}
          <b-tooltip
            type="is-dark"
            label="1000x700/限定jpg檔，600KB內"
            position="is-bottom"
          >
            <b-icon size="is-small" icon="help-circle-outline"></b-icon>
          </b-tooltip>
        </template>
        <b-field class="file">
          <a class="button is-primary" @click="onSelectRouterImage">
            <b-icon icon="upload"></b-icon>
            <span>{{ $t('message.please_select_file') }}</span>
          </a>
          <p
            v-if="form.picture2"
            class="tag is-warning"
            style="margin-left: 4px; height: 36px"
          >
            <a
              :href="productImageUrl(form.picture2)"
              @click.prevent="onClickImage(form.picture2)"
            >
              {{ form.picture2 }}
            </a>
          </p>
        </b-field>
      </b-field>

      <b-field horizontal grouped>
        <template #label>
          {{ $t('attributes.banner_picture') }}
          <b-tooltip
            type="is-dark"
            label="1920x800/限定jpg檔，600KB內"
            position="is-bottom"
          >
            <b-icon size="is-small" icon="help-circle-outline"></b-icon>
          </b-tooltip>
        </template>
        <b-field class="file">
          <a class="button is-primary" @click="onSelectBackgroundImage">
            <b-icon icon="upload"></b-icon>
            <span>{{ $t('message.please_select_file') }}</span>
          </a>
          <p
            v-if="form.picture3"
            class="tag is-warning"
            style="margin-left: 4px; height: 36px"
          >
            <a
              :href="productImageUrl(form.picture3)"
              @click.prevent="onClickImage(form.picture3)"
            >
              {{ form.picture3 }}
            </a>
          </p>
        </b-field>
      </b-field>

      <b-field horizontal>
        <b-button
          disabled="disabled"
          :loading="sending"
          type="is-primary"
          native-type="submit"
          :style="{ width: '100%' }"
        >
          {{ $t('attributes.update_data') }}
        </b-button>
      </b-field>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="productImageUrl(selectedImageUrl)" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import {
  OpenProductCoverFinder,
  OpenProductRouteFinder,
  OpenProductBackgroundFinder
} from '@/utils/ckfinder'
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'PicturesForm',

  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,
      form: this.extractFormValues(this.travelGroup),

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  watch: {
    travelGroup(newGroup) {
      this.form = this.extractFormValues(newGroup)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        picture1: data.picture4, // Cover Image
        picture2: data.picture2, // Router Image
        picture3: data.picture3 // Background Image
      }
    },
    async onSelectCoverImage() {
      try {
        this.form.picture1 = await OpenProductCoverFinder(
          this.travelGroup.image_path
        )
      } catch (e) {
        notifyService.error(e)
      }
    },
    async onSelectRouterImage() {
      try {
        this.form.picture2 = await OpenProductRouteFinder(
          this.travelGroup.image_path
        )
      } catch (e) {
        notifyService.error(e)
      }
    },
    async onSelectBackgroundImage() {
      try {
        this.form.picture3 = await OpenProductBackgroundFinder(
          this.travelGroup.image_path
        )
      } catch (e) {
        notifyService.error(e)
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    async onSend() {
      const api = `${TRAVEL_GROUPS_API}/${this.travelGroup.code}/pictures`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)

        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
